import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
} from "react-router-dom";
import Authentication from "./components/Authentication";
import Layout from "./components/Layout";
import LayoutNoNav from "./components/LayoutNoNav";
import Page404 from "./pages/errors/Page404";
import { Suspense, useEffect } from "react";
import {
  hideToolsRoutes,
  lightNavRoutes,
  noNavRoutes,
} from "./routes/specialRoutes";
import { routes } from "./routes/regularRoutes";
import "./utils/featureFlags";
import { useSyncAuthWithFeatureFlags } from "./utils/featureFlags";
import { useShortbread } from "./contexts/shortbread";
import Box from "@amzn/awsui-components-console/box";
import Spinner from "@amzn/awsui-components-console/spinner";
import DailyMarketingPortalModal from "./components/DailyMarketingPortalModal";

function FeatureFlagAuthSync(): null {
  try {
    useSyncAuthWithFeatureFlags();
  } catch (error) {
    console.error("Error syncing auth with feature flags:", error);
  }
  return null;
}

function CookieConsentInit(): null {
  const { checkForCookieConsent, isInitialized } = useShortbread();

  useEffect(() => {
    if (isInitialized) {
      checkForCookieConsent();
    }
  }, [isInitialized, checkForCookieConsent]);

  return null;
}

export default function App() {
  return (
    <Authentication>
      <FeatureFlagAuthSync />
      <CookieConsentInit />
      <DailyMarketingPortalModal />
      <RouterProvider
        router={createBrowserRouter([
          {
            element: (
              <Suspense
                fallback={
                  <Box textAlign="center" padding="xxl">
                    <Spinner />
                  </Box>
                }
              >
                <Outlet />
              </Suspense>
            ),
            errorElement: <Page404></Page404>,
            children: noNavRoutes,
          },
          {
            element: <Layout />,
            errorElement: <Page404></Page404>,
            children: routes,
          },
          {
            element: <Layout hideTools />,
            errorElement: <Page404></Page404>,
            children: hideToolsRoutes,
          },
          {
            element: <LayoutNoNav />,
            errorElement: <Page404></Page404>,
            children: lightNavRoutes,
          },
          {
            path: "*",
            element: <Navigate to="/" replace />,
          },
        ])}
      />
    </Authentication>
  );
}
